import { render } from "./vcoupondata.vue?vue&type=template&id=c0f285fe&scoped=true"
import script from "./vcoupondata.vue?vue&type=script&lang=js"
export * from "./vcoupondata.vue?vue&type=script&lang=js"

import "./vcoupondata.vue?vue&type=style&index=0&id=c0f285fe&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0f285fe"]])

export default __exports__